/* DHC B284 — cart focus containment + restoration. */
(()=>{"use strict";
const drawer=document.querySelector("[data-cart-drawer]");
if(!drawer)return;
const close=drawer.querySelector("[data-close-cart-drawer]");
if(!drawer.hasAttribute("aria-labelledby"))drawer.setAttribute("aria-labelledby","DHCCartDrawerTitle");
let previous=null,wasOpen=false;
const isOpen=()=>drawer.classList.contains("is-open")||drawer.getAttribute("aria-hidden")==="false";
const focusables=()=>Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')).filter(el=>!!(el.offsetWidth||el.offsetHeight||el.getClientRects().length));
function onOpen(){
 previous=document.activeElement instanceof HTMLElement?document.activeElement:null;
 requestAnimationFrame(()=>{const items=focusables();(close||items[0])?.focus({preventScroll:true});});
}
function onClose(){
 if(previous&&document.contains(previous)){try{previous.focus({preventScroll:true})}catch(_){}}
 previous=null;
}
const sync=()=>{const open=isOpen();if(open&&!wasOpen)onOpen();if(!open&&wasOpen)onClose();wasOpen=open;};
new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:["class","aria-hidden"]});
document.addEventListener("keydown",e=>{
 if(!isOpen())return;
 if(e.key==="Escape"){e.preventDefault();close?.click();return;}
 if(e.key!=="Tab")return;
 const items=focusables();if(!items.length)return;
 const first=items[0],last=items[items.length-1],active=document.activeElement;
 if(e.shiftKey&&active===first){e.preventDefault();last.focus();}
 else if(!e.shiftKey&&active===last){e.preventDefault();first.focus();}
});
sync();
})();